export const StoreConstants = {
  SHOP_ORIGIN_CONFIGURATION: "SHOP_ORIGIN_CONFIGURATION",
  PREFERED_SCAN_CAMERA: "PREFERED_SCAN_CAMERA",
}